import { menuRegistry } from '@/common/menu/menuRegistry';
import { registerRouteForModule } from '@/common/route/registerModules';
import router, { ROUTE_NAME_MAIL } from './router';

menuRegistry.registerMenu([
    {
        parent: 'General',
        key: 'MailSetting',
        name: 'Mail Setting',
        icon: 'fas fa-envelope',
        route: { name: ROUTE_NAME_MAIL.SETTING }
    }
]);

export default registerRouteForModule(router);
